import { useIntl } from 'react-intl';
import { MouseEventHandler, useCallback } from 'react';

import { useRudderStack } from '@ocx-app/lib/rudderStack/useRudderStack';

import { Markdown, Note } from '@ocx/ui';
import { logInDev } from '@ocx/utils';
import { openUrlInWindow } from '@ocx/utils-device';
import { EnvConfiguration } from '@ocx/data-configuration';

import { messages } from '../../signup.messages';

export type DisclaimerProps = {
  termsOfServiceLink: string;
  privacyPolicyLink: string;
  optOutUrl?: string;
};

export const Disclaimer = (props: DisclaimerProps) => {
  const intl = useIntl();
  const { triggerEvent } = useRudderStack();

  const { termsOfServiceLink, privacyPolicyLink, optOutUrl } = props;

  const handleOptOutLinkClick: MouseEventHandler<HTMLAnchorElement> = useCallback(
    (event) => {
      if (!optOutUrl) {
        return;
      }

      event.preventDefault();

      openUrlInWindow({ url: optOutUrl, nativeMode: 'systemBrowser' }).catch(logInDev);
      triggerEvent('personal_data_share_opt_out_link_clicked');
    },
    [optOutUrl, triggerEvent],
  );

  return (
    <Note textAlign="left" mt="auto">
      <Markdown variant="caption" color="textSecondary">
        {intl.formatMessage(messages['signUp:disclaimer:markdown'], {
          marketingTitle: EnvConfiguration.marketing.title,
          termsOfServiceLink,
          privacyPolicyLink,
        })}
      </Markdown>
      {optOutUrl ? (
        <Markdown variant="caption" color="textSecondary" aProps={{ onClick: handleOptOutLinkClick }}>
          {intl.formatMessage(messages['signUp:disclaimer:personalDataShareOptOut:markdown'], { optOutUrl })}
        </Markdown>
      ) : null}
    </Note>
  );
};
